import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs-compat';
import { LoggerService } from '../services/logger.service';
import { LineStateActionService } from '../statemanagement/line-state-action.service';

@Component({
    selector: 'app-claim-form',
    templateUrl: './claim-form.component.html',
    styleUrls: ['./claim-form.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ClaimFormComponent implements OnInit {

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private loggerService: LoggerService,
    private lineStateAction: LineStateActionService,
  ) { }
 
  token: string = new Date().valueOf().toString();
  accident_no: string = "";
  serviceLocation: string = "";
  liffId: string = "";
  ngOnInit() {
    // this.bindData().subscribe(res => {
    //   this.setSessionStorage();
    //   this.redirect();
    // });

    this.getParams();
    this.setSessionStorage();
    this.redirect();
  }

  getParams(): void {
    const queryParams = this.route.snapshot.queryParams;
    this.accident_no = queryParams['accident_no'];
    this.serviceLocation = queryParams['service_location'];
    this.liffId = queryParams['liffId'];
  }

  // bindData(): Observable<boolean> {
  //   return new Observable(obs => {
  //     this.route.queryParams
  //       .subscribe((params) => {
  //         console.log(['claim params:', params])
  //         this.claim = params['claim'];
  //         obs.next(true);
  //       });
  //   })
  // }

  redirect() {
    this.router.navigate(['claim','c','appointment-form',this.token], { relativeTo: null , queryParams: { liffId: this.liffId } });
  }

  setSessionStorage() {
    const channel = this.lineStateAction.channelStateInfo;
    const identity = this.lineStateAction.identityStateInfo;
    const customer = this.lineStateAction.customerStateInfo;

    let json = {
      channel: channel,
      identity: identity,
      customer: customer,
      accident_no: this.accident_no,
      service_location:this.serviceLocation,
      sub_flow: channel.subflow
    };
    sessionStorage.setItem(this.token, JSON.stringify(json));
  }



}
